<script setup lang="ts">
interface IProps {
    disabled?: boolean;
    eager?: boolean;
}

const { disabled, eager } = defineProps<IProps>();
defineOptions({ inheritAttrs: false });

const root = ref<HTMLDivElement>();
const isLoading = ref(!disabled && !eager);

watchPostEffect(onCleanup => {
    if (!isLoading.value || !root.value) {
        return;
    }
    if (disabled || eager || typeof IntersectionObserver === 'undefined') {
        isLoading.value = false;
        return;
    }

    const observer = new IntersectionObserver(
        entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                isLoading.value = false;
            }
        },
        { rootMargin: '300px 0px' }
    );
    observer.observe(root.value);
    onCleanup(() => observer.disconnect());
});

defineExpose({ root });
</script>

<template>
    <div ref="root" class="lazy-mount" v-bind="$attrs">
        <slot v-if="isLoading" name="loading" />
        <slot v-else />
    </div>
</template>

<style scoped>
.lazy-mount {
    width: 100%;
}
</style>
